module.exports = __webpack_public_path__ + "static/media/5.fc2f8a62.png";